<template src="./driverassets.html"></template>
<script>
import { mapState } from "vuex";
import Axios from "axios";
import DocumentPopup from "@/pages/vehicles/vehicledocumentspopup/vehicledocumentspopup.vue";
var moment = require("moment");
export default {
  components: {
    DocumentPopup,
  },
  filters: {
    date: function (data) {
      var sendDate = "N/A";
      if (data != "" && data != null) {
        sendDate = moment(data).format("DD-MM-YYYY");
      }
      return sendDate;
    },
  },
  //props: ["VehicleId"],
  data() {
    return {
      ImageEndpoint: Endpoints.Helper.Image + "/",
      AssetsList: [],
    };
  },
  mounted() {
    setTimeout(() => {
      this.DriverId = this.$route.params.DriverId;   
      //console.log('this.DriverId',this.DriverId)        
      this.GetDriverAssets();
    }, 4000);
    var CompanyData = JSON.parse(localStorage.getItem("Company"));    
  },
  methods: {
    GetDriverAssets() {
      var obj = { token: localStorage.getItem("token") };
      obj.driver_id = this.DriverId;      
      Axios.post(Endpoints.Driver.AssignedAssets, obj).then((Response) => {
        if (Response?.data?.success) {
          this.AssetsList = Response.data.AssetsList;          
        }
      });
    },    
  },
};
</script>
<style scoped>
.download-excel-btn {
  float: right;
  margin-right: 10px;
}
</style>
